import React, { Component } from "react";
import TransferInterentidadService from "../../../../services/transferencias/TransferInterentidadService";
import Popup from "react-popup";

import $ from "jquery";
import { CustomSelect } from "../../../generico/Transferencia/Interbancarias/CustomSelect";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faSave, faSearch } from "@fortawesome/free-solid-svg-icons";
import history from "../../login/history";
import ConfigService from "../../../../services/configuracion/ConfigService";

export default class PopupAgreagarAlias extends Component {

  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    this.guardar = this.guardar.bind(this);
    this.validate = this.validate.bind(this);
   
  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  initData() {
 
 //  this.buscar.disabled = true;
   //this.setState({habilitarGuardar:true});
 
  }

  getInitialState = () => ({
    entidadNew: "",
    nroCuentaNew: "",
    nombreApellidoNew: "",
    tipoDocNew: "",
    aliasNew: "",
    tipoAliasNew: "",
    tipoAliasId: "",
    tipoEntidadNew: "",
    documentoNew: "",
    hiddenNroCuenta: false,
    disabledEntidad: false,
    disabledTipoDoc: false,
    mostrarDatosCuenta: false,
    mostrarMensajeCuenta: false,
    mostrarCuentaCu: false,
    loading: false,
    datos: {
      numCuenta: '123456'
    },
    data: {},
    mostrarCorreo: false,
    valorEjemplo: '',
    alias: '',
    buscar:false,
    habilitarGuardar:false,
    
  });

  componentDidUpdate(prevProps, prevState) {
    
    if (this.state.data.esCuentaCU && !prevState.data.esCuentaCU) {
      this.setState({ mostrarCuentaCu: true });
    }
    /*if(this.state.tipoAliasNew && this.state.alias ){
      this.setState({ buscar: false });
    }*/

  }
  buscarAlias() {
    /*  this.setState({  mostrarDatosCuenta:true });
      this.setState({
        data: {
  
          "titular": "PERSONA NRO 544572",
          "tipoDocumento": "CI",
          "numDocumento": "5100159",
          "codBic": "BNITPYPA",
          "numCuenta": "1021841",
          "codParticipante": null,
          "codEntidad": "42",
          "descEntidad": "BANCO ATLAS S.A.",
          "tipoCuentaDestino": "BANCOD",
          "esCuentaCU":false
  
        }
      });
      if(this.state.data.esCuentaCU){
        this.setState({mostrarCuentaCu:true, mostrarDatosCuenta: true })
      }*/
        
    this.setState({ loading: true,mostrarDatosCuenta: false, habilitarGuardar: false});
   
    if (this.state.alias != null && this.state.tipoAliasNew != null) {
      TransferInterentidadService.getDatosAlias(
        this.state.alias,
        this.state.tipoAliasNew,

      )
        .then((response) => {
          this.setState({
            loading: false,
          });
          var data = JSON.stringify(response.data);
          var jData = JSON.parse(data);
          
          if (jData.codigoRetorno === "0") {
           
            this.setState({ mostrarDatosCuenta: true,data: jData.datos, habilitarGuardar: true  });

          
            //  this.setState(this.getInitialState());
            //this.modalCuenta.click();
            // this.props.addCuentaCallback("OK");
          } else {
            // ✅ Ocultar loading al error
            Popup.queue(this.notifiPopup("Estimado Socio", jData.mensajeRetorno));
            this.props.addCuentaCallback("FAIL");
            this.setState({
              loading: false,
            });
          }

        })
        .catch((error) => {
          console.log("Error en la llamada al servicio:", error);
      
          let mensaje = "Ocurrió un error al consultar el alias.";
          if (error.code === "ECONNABORTED" || error.message?.includes("timeout")) {
            mensaje = "La consulta ha excedido el tiempo de espera. Intente nuevamente.";
          }
      
          Popup.queue(this.notifiPopup("Error de conexión", mensaje));
          this.props.addCuentaCallback("FAIL");
          this.setState({ loading: false });
        });
       
    }
  }

  PREFIJO = "+595"; // o lo que necesites como prefijo para móviles

  verificarTipo = (tipoAliasSeleccionado) => {
    let mostrarCorreo = false;
    let valorEjemplo = '';
    let alias = '';

    if (tipoAliasSeleccionado !== null) {
      mostrarCorreo = true;
    }

    switch (tipoAliasSeleccionado) {
      case "CI":
        valorEjemplo = "Ej: 1234567";
        break;
      case "EMAIL":
        valorEjemplo = "Ej: correo@gmail.com";
        break;
      case "MOBILE":
        alias = this.PREFIJO;
        valorEjemplo = "Ejemplo: 981234567";
        break;
      case "RUC":
        valorEjemplo = "Ej: 1234567-2";
        break;
      default:
        valorEjemplo = "";
        break;
    }
   

    this.setState({
      tipoAliasNew: tipoAliasSeleccionado,
      mostrarCorreo,
      valorEjemplo,
      alias,
    });
  }

  habilitarBuscar(alias, tipoAlias) {
    if (tipoAlias && alias) {
      this.setState({ buscar: true });
    } else {
      this.setState({ buscar: false });
    }
  }

  guardar() {
    const tipoSeleccionadoId = this.props.tipos.find(item => item.descripcion === this.state.data.tipoDocumento);
    TransferInterentidadService.addCuentaExterna(
      this.state.data.titular,
      this.state.data.numCuenta,
      tipoSeleccionadoId.id,
      this.state.data.numDocumento,
      this.state.data.codEntidad,
      this.state.alias,
      this.state.tipoAliasNew
    )
      .then((response) => {
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);
        if (jData.codigo === 0) {
          this.setState(this.getInitialState());
          this.modalCuenta.click();
          this.props.addCuentaCallback("OK");
          Popup.queue(this.notifiPopup('Exito','Se ha creado el alias correctamente.'));
        } else {
          Popup.queue(this.notifiPopup("Error", jData.mensaje));
          this.props.addCuentaCallback("FAIL");
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }
  validate = (e) => {
    $.validator.addMethod("dataType", (value, element) => {
      if (
        this.state.tipoDocNew === "3" &&
        isNaN(Number(this.state.documentoNew))
      ) {
        return false;
      }

      return true;
    });

    $("#idFormAddCuenta").validate({
      submitHandler: () => {
        this.guardar();
      },
      rules: {
        entidadNew: {
          required: true,
        },
        nroCuentaNew: {
          required: true,
        },
        nombreApellidoNew: {
          required: true,
        },
        tipoDocNew: {
          required: true,
        },
        documentoNew: {
          required: true,
          dataType: { dataType: true },
        },
      },
      messages: {
        entidadNew: {
          required: "Este campo es requerido",
        },
        nroCuentaNew: {
          required: "Este campo es requerido",
          number: "Favor ingrese un número válido, sin guión ni caracteres especiales",
        },
        nombreApellidoNew: {
          required: "Este campo es requerido",
        },
        tipoDocNew: {
          required: "Este campo es requerido",
        },
        documentoNew: {
          required: "Este campo es requerido",
          dataType: "Sólo números para Cédula de Identidad",
        },
      },
      errorElement: "span",
      errorPlacement: function (error, element) {
        error.addClass("invalid-feedback");
        element.closest(".form-group").append(error);
      },
      highlight: function (element, errorClass, validClass) {
        $(element).addClass("is-invalid");
      },
      unhighlight: function (element, errorClass, validClass) {
        $(element).removeClass("is-invalid");
      },
    });
  };

  onChangeTipoEntidad = (tipoEntidadNew) => {

    if (tipoEntidadNew === "TARJETA DIMO") {
      this.setState({
        entidadNew: "1600",
        tipoEntidadNew,
        tipoDocNew: "3",
        nroCuentaNew: "",
        hiddenNroCuenta: true,
        disabledEntidad: true,
        disabledTipoDoc: true
      });
    } else {
      this.setState({
        entidadNew: "",
        tipoEntidadNew,
        hiddenNroCuenta: false,
        disabledEntidad: false,
        disabledTipoDoc: false
      });
    }

  }
  copiarNumeroCuenta = () => {
    const numero = this.state.data?.numCuenta;
    if (navigator.clipboard && numero) {
      navigator.clipboard.writeText(numero)
        .then(() => {
          console.log('Número de cuenta copiado');
          // Opcional: toast o alert
        })
        .catch(err => {
          console.error('Error al copiar al portapapeles', err);
        });
    }
  };

  irTransferenciaEntreSocios = (e) => {
    history.push(ConfigService.getPathByName("transferenciaTercero")?.url);
    window.location.reload();
  }

  render() {

    let listEntidades = this.props.items.filter((item) => item.nombreTipoEntidad === this.state.tipoEntidadNew);

    const listTiposDocumentos = this.props.tipos.map((elemento) => (
      <option key={elemento.id} value={elemento.id}>
        {elemento.descripcion}
      </option>
    ));

    listTiposDocumentos.unshift(
      <option key="-1" value="" disabled>
        -- Seleccione--
      </option>
    );

    return (
      <form
        id="idFormAddCuenta"
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <div
          className="modal fade"
          id="modal-alias"
          data-backdrop="false"
        >
          <div className="modal-dialog  modal-dialog-centered  modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Datos del Alias</h5>
              </div>
              <div className="modal-body">
                <div className="row">
                
                  <div className="col-6">
                    <CustomSelect
                      label={"Tipo de Alias"}
                      name={"tipoAliasNew"}
                      value={this.state.tipoAliasNew}
                      disabled={this.state.disabledTipoDoc}
                      itemList={this.props.tiposAlias}
                      onChangeItem={(val) => {
                        const tipoSeleccionado = this.props.tiposAlias.find(item => item === val);
                        this.setState({ tipoAliasNew: tipoSeleccionado},() => {
                          this.habilitarBuscar(this.state.alias, this.state.tipoAliasNew);
                        });
                       
                        this.verificarTipo(tipoSeleccionado);

                      }}
                    />
                  </div>
                  <div className="col-6">
                    <div className="form-group">
                      <label className="input-label">Alias</label>

                      {this.state.tipoAliasNew !== "MOBILE" ? (
                        <input
                          type="text"
                          name="alias"
                          className="input-form input-box form-control"

                          value={this.state.alias}
                          onChange={(e) => {
                            const inputVal = e.target.value;

                            this.setState({ alias: inputVal }, () => {
                              this.habilitarBuscar(this.state.alias, this.state.tipoAliasNew);
                            });
                          }}
                        />
                      ) : (
                        <input
                          type="texto"
                          name="alias"
                          className="input-form input-box form-control"

                          value={this.state.alias}
                          onChange={(e) => {
                            const inputVal = e.target.value;

                            this.setState({ alias: inputVal }, () => {
                              this.habilitarBuscar(this.state.alias, this.state.tipoAliasNew);
                            });
                          }}
                        />
                      )}
                      <div className="ion-text">
                        {this.state.mostrarCorreo && (
                          <p className="texto-tipo" style={{color: '#767674;'}}>{this.state.valorEjemplo}</p>
                        )}
                      </div>
                    </div>
                  </div>
                    <div className="row col-md-12">
                    <div className="col-md-4">
                    </div>
                    <div className="col-md-4">
                      <button
                        className="btn btn-cu-primary"
                        disabled={!this.state.buscar}
                        ref={(button) => (this.buscar = button)}
                        onClick={() => {
                          this.buscarAlias();
                        }}
                      >
                        <FontAwesomeIcon icon={faSearch} />  Buscar
                      </button>
                    </div>
                    </div>
                
                  {this.state.loading && (
                    <div className="loading-overlay">
                      Buscando...
                    </div>
                  )}
                  {this.state.mostrarDatosCuenta && (
                    <div className="col-md-12">
                      <div className="card-alias item ion-activatable ripple-parent" style={{ borderRadius: 10, padding: '16px 16px, 0, 16px', marginBottom: 16 }}>
                        <div className="cabecera" style={{ fontSize: 18, display: 'flex', alignItems: 'center', gap: 8 }}>
                          {this.state.mostrarCuentaCu && (<div className="row">
                            <div className="col-md-12">
                              <div class="mt-3" style={{ fontSize: 14, color: '#181818 !important' }}>
                                Esta cuenta pertenece a la CU. Favor realizar la transferencia desde la opción Transferencia entre socios
                              </div>
                            </div>
                          </div>)}
                        </div>
                        <div style={{ fontSize: 15, marginTop: 12, border: 'solid 1px #cccccc', padding: '3%', borderRadius: '5px' }}>
                          <p className="detalle" style={{ marginBottom: 3 }}><strong>Nombre:</strong> {this.state.data?.titular}</p>
                          <p className="detalle" style={{ marginBottom: 3 }}><strong>Banco:</strong>{this.state.data?.descEntidad}</p>
                          <p className="detalle" style={{ marginBottom: 3 }}>  <span style={{
                            backgroundColor: '#20a195',
                            color: '#fff',
                            fontSize: 12,
                            padding: '3px 6px',
                            borderRadius: 6,
                            lineHeight: 1,
                          }}>
                            Alias
                          </span> <strong>{this.state.tipoAliasNew}:</strong> {this.state.alias}</p>

                          <p className="detalle">
                            <strong>Cuenta Número:</strong> {this.state.data?.numCuenta}
                          </p>
                          {this.state.mostrarCuentaCu && (<button style={{
                            backgroundColor: '#f4b400',
                            color: '#000',
                            fontSize: 12,
                            padding: '5px 8px',
                            borderRadius: 4,
                            lineHeight: 1,
                            border: 'inherit',
                          }} onClick={this.copiarNumeroCuenta}>Copiar</button>
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                </div>
              </div>
              <div className="modal-footer">
                <div className="col-md-12">
                  <div className="row">
                    <div className="col-md-6">
                      <button
                        type="button"
                        className="btn btn-cu-quintary btn-consulta"
                        data-dismiss="modal"
                        aria-label="Close"
                        onClick={() => {
                          $("#idFormAddCuenta").validate().resetForm();
                          this.setState(this.getInitialState());
                        }}
                      >
                        <FontAwesomeIcon icon={faClose} /> Cerrar
                      </button>
                    </div>
                    <div className="col-md-6">
                      {!this.state.mostrarCuentaCu && (<button
                        className="btn btn-cu-primary"
                        disabled={!this.state.habilitarGuardar}
                        ref={(button) => (this.habilitarGuardar = button)}
                        onClick={() => {
                          this.guardar();
                        }}
                      >
                        <FontAwesomeIcon icon={faSave} />  Guardar
                      </button>
                      )}

                      {this.state.mostrarCuentaCu && (

                        <button
                          className="btn btn-cu-primary"
                          onClick={this.irTransferenciaEntreSocios}
                        >
                          Ir a Transferencia entre Socios
                        </button>

                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /.modal-content */}
          </div>
          {/* /.modal-dialog */}
          <a
            data-controls-modal="modal-alias"
            ref={(a) => (this.modalCuenta = a)}
            data-backdrop="false"
            href="##"
            hidden
            id="showModalCuenta"
            data-toggle="modal"
            data-target={"#modal-alias"}
          ></a>
        </div>
      </form >

    );
  }
}
